import React from 'react';
import { SearchX } from 'lucide-react';

export const TableSkeleton = ({ columns, rows = 5 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <tr key={rowIdx} className="border-bottom bg-white">
          {Array.from({ length: columns }).map((_, colIdx) => (
            <td key={colIdx} className="px-4 py-3">
              <span
                className="placeholder rounded-pill"
                style={{
                  width: `${Math.floor(Math.random() * 40) + 40}%`,
                  display: 'inline-block',
                  height: '12px',
                  backgroundColor: '#e2e8f0'
                }}
              ></span>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export const EmptyState = ({ message = 'No records found' }) => {
  return (
    <tr>
      <td className="p-5 text-center bg-white" colSpan={100}>
        <div className="d-flex flex-column align-items-center justify-content-center py-5">
          <div
            className="rounded-circle bg-light d-flex align-items-center justify-content-center shadow-sm mb-3"
            style={{ width: '80px', height: '80px' }}
          >
            <SearchX size={40} className="text-secondary" strokeWidth={1.5} />
          </div>
          <div>
            <h4 className="fw-bold text-dark mb-1">{message}</h4>
            <p className="text-muted small mx-auto mt-1" style={{ maxWidth: '400px' }}>
              We couldn't find any data matching your current criteria. Try adjusting your filters
              or reloading the page.
            </p>
          </div>
        </div>
      </td>
    </tr>
  );
};
